export default __webpack_public_path__ + "static/media/Crossbow of the Undefeated.114eec4c.jpg";